/** Spanish number-line prompt (ADR 0051 part 3). */
export const numberLinePrompts = {
    arrow: () => `¿A qué número apunta la flecha?`,
};
